import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

import type { IModalDialogContent, ModalDialogOptions, ModalWindow } from '@components/Modal.tsx';
import { ModalButtonType } from '@components/Modal.tsx';
import { uploadService } from '@services/uploadService.ts';

@observer
export class UrlUploadDialog extends React.Component<{ parentFolderId?: string | null }> implements IModalDialogContent<void> {
  @observable private _url = '';

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }

  getModalOptions(window: ModalWindow<void>): ModalDialogOptions<void> {
    return {
      title: 'Upload from URL',
      width: '500px',
      closeByEscape: true,
      closeOnClickOutside: true,
      buttons: [
        {
          title: 'Download',
          type: ModalButtonType.Ok,
          color: 'primary',
          onClick: () => {
            const url = this._url.trim();
            if (url) {
              uploadService.uploadFromUrl(url, this.props.parentFolderId);
              window.close(ModalButtonType.Ok);
            }
          },
        },
        {
          title: 'Cancel',
          type: ModalButtonType.Cancel,
          onClick: () => window.close(ModalButtonType.Cancel),
        },
      ],
    };
  }

  render() {
    return (
      <div>
        <input
          type="url"
          className="form-control"
          placeholder="Paste a URL to download..."
          value={this._url}
          onChange={this._onChange}
          onKeyDown={this._onKeyDown}
          autoFocus
        />
      </div>
    );
  }

  @action.bound
  private _onChange(e: React.ChangeEvent<HTMLInputElement>) {
    this._url = e.target.value;
  }

  private _onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const url = this._url.trim();
      if (url) {
        uploadService.uploadFromUrl(url);
        // close is handled by the modal window's escape / button
      }
    }
  };
}
